

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { UserGroupFormComponent } from './usergroup-form/usergroup-form.component';
import { UserGroupComponent } from './usergroup.component';
import { UserGroupRoutes } from './usergroup.routing';

export function declaration() {
    return [UserGroupComponent, UserGroupFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class UserGroupModule {
}

@NgModule({
    imports: [UserGroupModule, UserGroupRoutes],
    exports: [UserGroupModule]
})
export class UserGroupWithRouteModule {
}
